import React from 'react';

const DefaultLayout = (props) => {
    return(
        <>
            <main className="py-4">
                <div className="container">
                    {props.children}
                </div>
            </main>
        </>
    )
}

export default DefaultLayout;